import { auth, db } from "../../../firebaseConfig"; // Make sure to import your Firebase configuration
import { doc, setDoc } from "firebase/firestore";
import { getSelectedUid } from "../../../../frontend/Recruitment/Applications/Utils/UidListener";


// Function to save form data for Section 8
export const writeDataS10 = async (formData) => {
  const userId = getSelectedUid(); // Get the selected UID
  if (!userId) {
    throw new Error("Invalid user.");
  }
  try {
    const docRef = doc(
      db,
      "Advisers",
      userId,
      "Application Details",
      "Unemployment Details"
    );

    await setDoc(
      docRef,
      {
        ...formData,
      },
      { merge: true }
    );
    // console.log("Section 10 data saved successfully.");
  } catch (error) {
    // console.error("Error writing Section 8 data to Firestore: ", error);
  }
};
